export default "__VITE_PUBLIC_ASSET__fdf25e55__"